<nav class="navigation">
  <a
    *ngFor="let item of navigationItems"
    [routerLink]="item.path"
    [routerLinkActiveOptions]="{ exact: true }"
    routerLinkActive="white"
    class="navigation__item light"
  >
    {{ item.title | t }}
  </a>
</nav>
